import {
    ChangeDetectionStrategy,
    Component, effect, inject,
    input,
    signal,
    viewChild,
    ViewEncapsulation
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { LoadingSpinnerComponent } from '../../../../loading';
import { IIFrameBlok } from './iframe.model';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-iframe',
    imports: [LoadingSpinnerComponent],
    templateUrl: './iframe.component.html',
    styleUrl: './iframe.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'block',
    },
})
export class IframeComponent {
    private  _sanitizer = inject(DomSanitizer);
    block = input.required<IIFrameBlok>();

    iframe = viewChild(HTMLIFrameElement);
    sanitizedLink = signal<SafeResourceUrl | null>(null);
    tariffLink = signal<SafeResourceUrl | null>(null);
    loading = signal<boolean>(true);

    constructor() {
        effect(() => {
            const block = this.block();
            if (block.url) {
                this.sanitizedLink.set(this._sanitizer.bypassSecurityTrustResourceUrl(block.url));
            }
            if (block.tariff_size && block.tariff_type) {
                this.tariffLink.set(
                    this._sanitizer.bypassSecurityTrustResourceUrl(environment['insurance'][block.tariff_type][block.tariff_size])
                );
            } else {
                this.tariffLink.set(null);
            }
        });
    }

    onLoad(iframe: HTMLIFrameElement): void {
        this.loading.set(false);
    }
}
